export default __webpack_public_path__ + "static/media/mysql.61d16d64.svg";